var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavouriteFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75532 1C3.13536 1 1.01074 3.216 1.01074 5.95C1.01074 8.157 1.84104 13.395 10.014 18.69C10.1604 18.7839 10.3285 18.8335 10.4999 18.8335C10.6713 18.8335 10.8393 18.7839 10.9857 18.69C19.1587 13.395 19.989 8.157 19.989 5.95C19.989 3.216 17.8644 1 15.2445 1C12.6245 1 10.4999 4 10.4999 4C10.4999 4 8.37527 1 5.75532 1Z",
    stroke: "#3CB4E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.01096 5.50002C1.01096 5.50002 4.0073 -2.49997 10.5001 4.00002L13.4965 1.50002H16.9925L19.4896 4.00002L19.989 8.00002L17.4919 13L10.5001 19C2.50925 14.6 0.844484 8.16669 1.01096 5.50002Z",
    fill: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteFilled);
export default __webpack_public_path__ + "static/media/favouriteFilled.e9f06242cdba240104e1b46663fa9286.svg";
export { ForwardRef as ReactComponent };